import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuth = () => {
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const verifyToken = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                setIsAuthenticated(false);
                // navigate('/login');
            } else {
                setIsAuthenticated(true);
            }
        };

        verifyToken();
    }, [navigate]);

    return isAuthenticated;
};

export default useAuth;